import { useState } from "react";
import "./PotentialMatch.css";

import Modal from "../Modal/Modal";

import Person from "../../Models/Person";

import MatchTable, { MatchHeader } from "../MatchTable/MatchTable";

/* Defines comparison table component which has two iterations:
  1.) One person is being compared to one other (yes/no question)
  2.) One person has multiple possible options (matching question, can also add an entirely new person) */

export function PotentialMatch({
  recordCandidate,
  treeCandidates,
  attached,
  setAttached,
  selectedCandidate,
  setSelectedCandidate,
  createPerson,
}: {
  recordCandidate: Person;
  treeCandidates: Person[];
  attached: boolean | undefined;
  setAttached: Function;
  selectedCandidate: number | undefined;
  setSelectedCandidate: Function;
  createPerson: Function;
}) {
  const [showSelectMatchModal, setShowSelectMatchModal]: [boolean, Function] =
    useState(false);

  return (
    <div className="potential-match">
      <h4>{recordCandidate.relationship}</h4>
      <div className="flex-row">
        <MatchTable
          selectedCandidate={selectedCandidate}
          recordCandidate={recordCandidate}
          treeCandidates={treeCandidates}
          createPerson={createPerson}
          setAttached={setAttached}
        />
      </div>
      <SelectBetweenMultipleMatchesModal />
    </div>
  );

  //This function is vestigial of Power Linker, and it may be useful later for Power Linker Lite
  function SelectBetweenMultipleMatchesModal() {
    return (
      <Modal show={showSelectMatchModal} setShow={setShowSelectMatchModal}>
        <>
          <fieldset>
            <legend>Choose from potential matches:</legend>
            {treeCandidates.map((treeCandidate, i) => (
              <label key={i}>
                <input
                  type="radio"
                  name={
                    recordCandidate.firstname + " " + recordCandidate.lastname
                  }
                  checked={selectedCandidate === i}
                  onChange={() => {
                    setSelectedCandidate(i);
                    setAttached(true);
                  }}
                  required
                />
                <MatchHeader
                  candidate={treeCandidate}
                  fromRecord={false}
                  match={false}
                />
              </label>
            ))}
          </fieldset>
          <footer>
            <button
              type="button"
              className="primary"
              onClick={() => setShowSelectMatchModal(false)}
            >
              Close
            </button>
          </footer>
        </>
      </Modal>
    );
  }
}
